import Vue from 'vue'
import { axios } from '@/utils/request'

//post
export function postAction(url, parameter, params) {
  return axios({
    url: url,
    method: 'post',
    data: parameter,
    ...params,
  })
}

//get
export function getAction(url, parameter, param = {}) {
  return axios({
    url: url,
    method: 'get',
    ...param,
    params: parameter,
  })
}

//post
export async function syncPostAction(url, parameter, params) {
  return await axios({
    url: url,
    method: 'post',
    data: parameter,
    ...params,
  })
}